import gql from "graphql-tag";

export const MY_TIMESHEET_GET_MESSAGES_LIST = gql`
  query listMyTimesheetMessages($request: String!) {
    listMyTimesheetMessages(request: $request) {
      _id
      request
      message
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      isDeleted
      employeeName
    }
  }
`;
